import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalTermsSectionComponent } from './modal-terms-section.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
    imports: [ CommonModule, SvgIconModule ],
    exports: [ ModalTermsSectionComponent ],
    declarations: [ ModalTermsSectionComponent ],
})
export class ModalTermsSectionModule {}
